import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { ModalView } from './ModalView';
export const PushNotificationDetails = ({ close, data, }) => (React.createElement(Modal, { show: true, onHide: close, centered: true, restoreFocus: false },
    React.createElement(ModalView, { data: data, close: close })));
